module.exports = __webpack_public_path__ + "img/icn_arrow.6bcc5dc3.png";